import Stamp from '@/api/stamp'

const MAX_STAMP_SIZE = 32

export interface StampState {
  stamps: any[]
}

const defaultState: StampState = {
  stamps: []
}

const state: StampState = Object.assign({}, defaultState)

const mutations = {
  setStamps(state: StampState, stamps: []) {
    state.stamps = stamps
  }
}

const actions = {
  /**
   * サーバからスタンプを取得する
   * 取得した状態では Object なので Array に変換する
   */
  async fetchStamps({ commit }, payload): Promise<any> {
    const data = await Stamp.fetchStamps(payload)
    if (data.error) {
      console.error(data.error)
      return
    }

    // flexbox で表示しているスタンプ一覧の履歴項目だけ位置がズレるのを防ぐ
    const historyLen = data.stamps[0].items.length
    if (historyLen !== MAX_STAMP_SIZE) {
      data.stamps[0].items = data.stamps[0].items.concat(new Array(MAX_STAMP_SIZE - historyLen))
    }

    commit('setStamps', Object.values(data.stamps))
  },

  /**
   * 使用したスタンプを履歴の先頭に追加する
   * 同じスタンプがあるなら古いものを削除
   */
  unshiftStampLogItem({ state }, item: { sid: number; img: string }) {
    state.stamps[0].items = state.stamps[0].items.filter(elem => {
      return elem.sid !== item.sid
    })
    state.stamps[0].items.unshift(item)
  }
}

const getters = {
  stamps: (state: StampState): any[] => state.stamps
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
